import { List_mapAll, String_startsWith, Parse_Decimal, Parse_Single, Parse_Float, Parse_UInt64, Parse_Int64, Parse_UInt32, Parse_Int32, Parse_UInt16, Parse_Int16, Parse_SByte, Parse_Byte, Result_Errorf } from "./More.fs.js";
import { map as map_2, some, orElseWith, defaultArgWith } from "../fable-library.3.7.20/Option.js";
import { copyTo, fill, equalsWith, choose, collect, mapIndexed, map as map_1 } from "../fable-library.3.7.20/Array.js";
import { equals, uncurry } from "../fable-library.3.7.20/Util.js";
import { FSharpChoice$7, FSharpChoice$6, FSharpChoice$5, FSharpChoice$4, FSharpChoice$3, FSharpChoice$2 } from "../fable-library.3.7.20/Choice.js";
import { tryParse } from "../fable-library.3.7.20/Boolean.js";
import { FSharpRef } from "../fable-library.3.7.20/Types.js";
import { toString, toUniversalTime, tryParse as tryParse_1, minValue } from "../fable-library.3.7.20/Date.js";
import { isDigit, isLetter } from "../fable-library.3.7.20/Char.js";
import { tryFind, remove } from "../fable-library.3.7.20/Map.js";
import { addToDict as addToDict_1, tryGetValue } from "../fable-library.3.7.20/MapUtil.js";
import { cons, empty, ofArray } from "../fable-library.3.7.20/List.js";
import { split } from "../fable-library.3.7.20/String.js";
import { Operators_Lock } from "../fable-library.3.7.20/FSharp.Core.js";
import { class_type } from "../fable-library.3.7.20/Reflection.js";
import { fold } from "../fable-library.3.7.20/Seq.js";

export function Errorf(f) {
    return Result_Errorf(f);
}

export function escape() {
    return (defThunk) => ((option) => defaultArgWith(option, defThunk));
}

export function oOr() {
    return (ifNoneThunk) => ((option) => orElseWith(option, ifNoneThunk));
}

export function const$0027(k, _arg) {
    return k;
}

export function flip(f, x, y) {
    return f(y, x);
}

export function pmap() {
    return (mapping) => ((array) => map_1(mapping, array));
}

export function pmapi() {
    return (mapping) => ((array) => mapIndexed(uncurry(2, mapping), array));
}

export function pcollect() {
    return (mapping) => ((array) => collect(mapping, array));
}

export function pchoose() {
    return (chooser) => ((array) => choose(chooser, array));
}

export function pfilter(predicate, array) {
    return pchoose()((x) => (predicate(x) ? some(x) : (void 0)))(array);
}

export function pmap2(f, t0, t1, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$2(1, _arg.fields[0](c))) : (new FSharpChoice$2(0, _arg.fields[0](c)))))([new FSharpChoice$2(0, t0), new FSharpChoice$2(1, t1)]);
    let pattern_matching_result, r0, r1;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 2)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                pattern_matching_result = 0;
                r0 = _arg_1[0].fields[0];
                r1 = _arg_1[1].fields[0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pmap3(f, t0, t1, t2, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$3(1, _arg.fields[0](c))) : ((_arg.tag === 2) ? (new FSharpChoice$3(2, _arg.fields[0](c))) : (new FSharpChoice$3(0, _arg.fields[0](c))))))([new FSharpChoice$3(0, t0), new FSharpChoice$3(1, t1), new FSharpChoice$3(2, t2)]);
    let pattern_matching_result, r0, r1, r2;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 3)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                if (_arg_1[2].tag === 2) {
                    pattern_matching_result = 0;
                    r0 = _arg_1[0].fields[0];
                    r1 = _arg_1[1].fields[0];
                    r2 = _arg_1[2].fields[0];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1, r2);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pmap4(f, t0, t1, t2, t3, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$4(1, _arg.fields[0](c))) : ((_arg.tag === 2) ? (new FSharpChoice$4(2, _arg.fields[0](c))) : ((_arg.tag === 3) ? (new FSharpChoice$4(3, _arg.fields[0](c))) : (new FSharpChoice$4(0, _arg.fields[0](c)))))))([new FSharpChoice$4(0, t0), new FSharpChoice$4(1, t1), new FSharpChoice$4(2, t2), new FSharpChoice$4(3, t3)]);
    let pattern_matching_result, r0, r1, r2, r3;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 4)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                if (_arg_1[2].tag === 2) {
                    if (_arg_1[3].tag === 3) {
                        pattern_matching_result = 0;
                        r0 = _arg_1[0].fields[0];
                        r1 = _arg_1[1].fields[0];
                        r2 = _arg_1[2].fields[0];
                        r3 = _arg_1[3].fields[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1, r2, r3);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pmap5(f, t0, t1, t2, t3, t4, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$5(1, _arg.fields[0](c))) : ((_arg.tag === 2) ? (new FSharpChoice$5(2, _arg.fields[0](c))) : ((_arg.tag === 3) ? (new FSharpChoice$5(3, _arg.fields[0](c))) : ((_arg.tag === 4) ? (new FSharpChoice$5(4, _arg.fields[0](c))) : (new FSharpChoice$5(0, _arg.fields[0](c))))))))([new FSharpChoice$5(0, t0), new FSharpChoice$5(1, t1), new FSharpChoice$5(2, t2), new FSharpChoice$5(3, t3), new FSharpChoice$5(4, t4)]);
    let pattern_matching_result, r0, r1, r2, r3, r4;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 5)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                if (_arg_1[2].tag === 2) {
                    if (_arg_1[3].tag === 3) {
                        if (_arg_1[4].tag === 4) {
                            pattern_matching_result = 0;
                            r0 = _arg_1[0].fields[0];
                            r1 = _arg_1[1].fields[0];
                            r2 = _arg_1[2].fields[0];
                            r3 = _arg_1[3].fields[0];
                            r4 = _arg_1[4].fields[0];
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1, r2, r3, r4);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pmap6(f, t0, t1, t2, t3, t4, t5, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$6(1, _arg.fields[0](c))) : ((_arg.tag === 2) ? (new FSharpChoice$6(2, _arg.fields[0](c))) : ((_arg.tag === 3) ? (new FSharpChoice$6(3, _arg.fields[0](c))) : ((_arg.tag === 4) ? (new FSharpChoice$6(4, _arg.fields[0](c))) : ((_arg.tag === 5) ? (new FSharpChoice$6(5, _arg.fields[0](c))) : (new FSharpChoice$6(0, _arg.fields[0](c)))))))))([new FSharpChoice$6(0, t0), new FSharpChoice$6(1, t1), new FSharpChoice$6(2, t2), new FSharpChoice$6(3, t3), new FSharpChoice$6(4, t4), new FSharpChoice$6(5, t5)]);
    let pattern_matching_result, r0, r1, r2, r3, r4, r5;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 6)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                if (_arg_1[2].tag === 2) {
                    if (_arg_1[3].tag === 3) {
                        if (_arg_1[4].tag === 4) {
                            if (_arg_1[5].tag === 5) {
                                pattern_matching_result = 0;
                                r0 = _arg_1[0].fields[0];
                                r1 = _arg_1[1].fields[0];
                                r2 = _arg_1[2].fields[0];
                                r3 = _arg_1[3].fields[0];
                                r4 = _arg_1[4].fields[0];
                                r5 = _arg_1[5].fields[0];
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1, r2, r3, r4, r5);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pmap7(f, t0, t1, t2, t3, t4, t5, t6, c) {
    const _arg_1 = pmap()((_arg) => ((_arg.tag === 1) ? (new FSharpChoice$7(1, _arg.fields[0](c))) : ((_arg.tag === 2) ? (new FSharpChoice$7(2, _arg.fields[0](c))) : ((_arg.tag === 3) ? (new FSharpChoice$7(3, _arg.fields[0](c))) : ((_arg.tag === 4) ? (new FSharpChoice$7(4, _arg.fields[0](c))) : ((_arg.tag === 5) ? (new FSharpChoice$7(5, _arg.fields[0](c))) : ((_arg.tag === 6) ? (new FSharpChoice$7(5, _arg.fields[0](c))) : (new FSharpChoice$7(0, _arg.fields[0](c))))))))))([new FSharpChoice$7(0, t0), new FSharpChoice$7(1, t1), new FSharpChoice$7(2, t2), new FSharpChoice$7(3, t3), new FSharpChoice$7(4, t4), new FSharpChoice$7(5, t5), new FSharpChoice$7(6, t6)]);
    let pattern_matching_result, r0, r1, r2, r3, r4, r5, r6;
    if ((!equalsWith(equals, _arg_1, null)) && (_arg_1.length === 7)) {
        if (_arg_1[0].tag === 0) {
            if (_arg_1[1].tag === 1) {
                if (_arg_1[2].tag === 2) {
                    if (_arg_1[3].tag === 3) {
                        if (_arg_1[4].tag === 4) {
                            if (_arg_1[5].tag === 5) {
                                if (_arg_1[6].tag === 6) {
                                    pattern_matching_result = 0;
                                    r0 = _arg_1[0].fields[0];
                                    r1 = _arg_1[1].fields[0];
                                    r2 = _arg_1[2].fields[0];
                                    r3 = _arg_1[3].fields[0];
                                    r4 = _arg_1[4].fields[0];
                                    r5 = _arg_1[5].fields[0];
                                    r6 = _arg_1[6].fields[0];
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return f(r0, r1, r2, r3, r4, r5, r6);
        }
        case 1: {
            throw (new Error("zip internal error"));
        }
    }
}

export function pZipMap(f, t0, t1, c) {
    return pmap2(f, t0, t1, c);
}

export function pZipMap3(f, t0, t1, t2, c) {
    return pmap3(f, t0, t1, t2, c);
}

export function pZipMap4(f, t0, t1, t2, t3, c) {
    return pmap4(f, t0, t1, t2, t3, c);
}

export function apply(x, f) {
    return f(x);
}

export function tryToOption(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    if (_arg[0]) {
        return some(_arg[1]);
    }
    else {
        return void 0;
    }
}

export function FSSome(x) {
    return some(x);
}

export function FSNone() {
    return void 0;
}

export function $007CBoolStr$007C_$007C(str) {
    const matchValue = str.toLocaleUpperCase();
    switch (matchValue) {
        case "FALSE": {
            return false;
        }
        case "TRUE": {
            return true;
        }
        default: {
            return void 0;
        }
    }
}

export function toBool(str) {
    let value = false;
    if (tryParse(str.trim(), new FSharpRef(() => value, (v) => {
        value = v;
    }))) {
        return value;
    }
    else {
        return void 0;
    }
}

export const $007CByteStr$007C_$007C = Parse_Byte;

export const $007CSByteStr$007C_$007C = Parse_SByte;

export const $007CInt16Str$007C_$007C = Parse_Int16;

export const $007CUInt16Str$007C_$007C = Parse_UInt16;

export const $007CInt32Str$007C_$007C = Parse_Int32;

export const $007CUInt32Str$007C_$007C = Parse_UInt32;

export const $007CInt64Str$007C_$007C = Parse_Int64;

export const $007CUInt64Str$007C_$007C = Parse_UInt64;

export const $007CFloatStr$007C_$007C = (allowComma) => ((str) => Parse_Float(allowComma, str));

export const $007CSingleStr$007C_$007C = (allowComma) => ((str) => Parse_Single(allowComma, str));

export const $007CDecimalStr$007C_$007C = (format) => ((str) => Parse_Decimal(format, str));

export const $007CDateTimeStr$007C_$007C = (str) => {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse_1(str, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export function $007CIso8601ZStr$007C_$007C(_arg) {
    throw (new Error("Use \u0027Time.UTC.Iso8601ZStr\u0027 instead"));
}

export function toIso8601(dt) {
    let copyOfStruct = toUniversalTime(dt);
    return toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ssZ");
}

export function $007CStartsWith$007C_$007C(start, str) {
    if (String_startsWith(start, str)) {
        return str;
    }
    else {
        return void 0;
    }
}

export function $007CStart$007C_$007C(start, str) {
    if (String_startsWith(start, str)) {
        return str.slice(start.length, str.length);
    }
    else {
        return void 0;
    }
}

export function $007CAlphaChr$007C_$007C(c) {
    if (isLetter(c)) {
        return c;
    }
    else {
        return void 0;
    }
}

export function $007CNumericChr$007C_$007C(c) {
    if (isDigit(c)) {
        return c;
    }
    else {
        return void 0;
    }
}

export function $007CAlphaNumericChr$007C_$007C(c) {
    if (isLetter(c) ? true : isDigit(c)) {
        return c;
    }
    else {
        return void 0;
    }
}

export function $007CMapKey$007C_$007C(key, map) {
    return map_2((x) => [x, remove(key, map)], tryFind(key, map));
}

export function $007CMapKeys$007C_$007C(keys, map) {
    return List_mapAll((key) => map_2((y) => [key, y], tryFind(key, map)), keys);
}

export function $007CDictKey$007C_$007C(key, dict) {
    let matchValue;
    let outArg = null;
    matchValue = [tryGetValue(dict, key, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return [matchValue[1], dict];
    }
    else {
        return void 0;
    }
}

export function $007CDictKeys$007C_$007C(keys, dict) {
    return List_mapAll((key) => {
        let matchValue;
        let outArg = null;
        matchValue = [tryGetValue(dict, key, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        return matchValue[0] ? [key, matchValue[1]] : (void 0);
    }, keys);
}

export function $007CSplitStr$007C_$007C(c, str) {
    return ofArray(split(str, [c], null, 0));
}

export function addToDict(d, key, value) {
    Operators_Lock(d, () => {
        if (d.has(key)) {
        }
        else {
            addToDict_1(d, key, value);
        }
    });
}

export function CSharp_ToFunc(f) {
    return f;
}

export function CSharp_ToFunc2(f) {
    return f;
}

export function CSharp_ToFunc3(f) {
    return f;
}

export class Buffer$1 {
    constructor(chunkSize) {
        this.chunkSize = (chunkSize | 0);
        this.currentChunk = fill(new Array(this.chunkSize), 0, this.chunkSize, null);
        this.currentChunkPos = 0;
        this.prevChunks = [];
    }
}

export function Buffer$1$reflection(gen0) {
    return class_type("Svea.Dry.Tools.Buffer`1", [gen0], Buffer$1);
}

export function Buffer$1_$ctor_Z524259A4(chunkSize) {
    return new Buffer$1(chunkSize);
}

export function Buffer$1_$ctor() {
    return Buffer$1_$ctor_Z524259A4(512);
}

export function Buffer$1__OnChunks(this$, fullFn, partialFn) {
    for (let i = 0; i <= (this$.prevChunks.length - 1); i++) {
        fullFn(this$.prevChunks[i]);
    }
    return partialFn(this$.currentChunk, this$.currentChunkPos);
}

export function Buffer$1__get_ChunkSize(this$) {
    return this$.chunkSize;
}

export function Buffer$1__get_CurrentOverhead(this$) {
    return this$.chunkSize - this$.currentChunkPos;
}

export function Buffer$1__get_Length(this$) {
    return (this$.prevChunks.length * this$.chunkSize) + this$.currentChunkPos;
}

export function Buffer$1__Get_Z524259A4(this$, index) {
    const chunkSize$0027 = this$.chunkSize | 0;
    const chunk = (~(~(index / chunkSize$0027))) | 0;
    const index$0027 = (index % chunkSize$0027) | 0;
    const prevChunks$0027 = this$.prevChunks;
    if (chunk < prevChunks$0027.length) {
        return prevChunks$0027[chunk][index$0027];
    }
    else {
        return this$.currentChunk[index$0027];
    }
}

export function Buffer$1__get_Item_Z524259A4(this$, index) {
    return Buffer$1__Get_Z524259A4(this$, index);
}

export function Buffer$1__IterI_121F4FF5(this$, fn) {
    const prevChunks$0027 = this$.prevChunks;
    const currentChunk$0027 = this$.currentChunk;
    let index = 0;
    for (let i = 0; i <= (prevChunks$0027.length - 1); i++) {
        const c = prevChunks$0027[i];
        for (let i_1 = 0; i_1 <= (this$.chunkSize - 1); i_1++) {
            fn(c[i_1], index);
            index = ((index + 1) | 0);
        }
    }
    for (let i_2 = 0; i_2 <= (this$.currentChunkPos - 1); i_2++) {
        fn(currentChunk$0027[i_2], index);
        index = ((index + 1) | 0);
    }
}

export function Buffer$1__Fold(this$, fn, seed) {
    let acc = seed;
    const prevChunks$0027 = this$.prevChunks;
    const currentChunk$0027 = this$.currentChunk;
    let index = 0;
    for (let i = 0; i <= (prevChunks$0027.length - 1); i++) {
        const c = prevChunks$0027[i];
        for (let i_1 = 0; i_1 <= (this$.chunkSize - 1); i_1++) {
            acc = fn(acc, c[i_1]);
            index = ((index + 1) | 0);
        }
    }
    for (let i_2 = 0; i_2 <= (this$.currentChunkPos - 1); i_2++) {
        acc = fn(acc, currentChunk$0027[i_2]);
        index = ((index + 1) | 0);
    }
    return acc;
}

export function Buffer$1__ToArray(this$) {
    const ret = fill(new Array(Buffer$1__get_Length(this$)), 0, Buffer$1__get_Length(this$), null);
    for (let i = 0; i <= (this$.prevChunks.length - 1); i++) {
        copyTo(this$.prevChunks[i], 0, ret, i * this$.chunkSize, this$.chunkSize);
    }
    copyTo(this$.currentChunk, 0, ret, this$.prevChunks.length * this$.chunkSize, this$.currentChunkPos);
    return ret;
}

export function Buffer$1__ToList(this$) {
    let ret = empty();
    for (let i$0027 = this$.currentChunkPos - 1; i$0027 >= 0; i$0027--) {
        ret = cons(this$.currentChunk[i$0027], ret);
    }
    for (let i = this$.prevChunks.length - 1; i >= 0; i--) {
        const chunk = this$.prevChunks[i];
        for (let i$0027_1 = this$.chunkSize - 1; i$0027_1 >= 0; i$0027_1--) {
            ret = cons(chunk[i$0027_1], ret);
        }
    }
    return ret;
}

export function Buffer$1__Append_2B595(this$, x) {
    this$.currentChunk[this$.currentChunkPos] = x;
    const currentChunkPos$0027 = (this$.currentChunkPos + 1) | 0;
    if (currentChunkPos$0027 === this$.chunkSize) {
        void (this$.prevChunks.push(this$.currentChunk));
        this$.currentChunkPos = 0;
        this$.currentChunk = fill(new Array(this$.chunkSize), 0, this$.chunkSize, null);
    }
    else {
        this$.currentChunkPos = (currentChunkPos$0027 | 0);
    }
}

export function Buffer_length(b) {
    return Buffer$1__get_Length(b);
}

export function Buffer_fold(fn, seed, b) {
    return Buffer$1__Fold(b, fn, seed);
}

export function Buffer_toArray(b) {
    return Buffer$1__ToArray(b);
}

export function Buffer_toList(b) {
    return Buffer$1__ToList(b);
}

export function Buffer_append(x, b) {
    Buffer$1__Append_2B595(b, x);
}

export function Buffer_appendSeq(xs, b) {
    fold((_arg, x) => {
        Buffer_append(x, b);
    }, void 0, xs);
}

export function Buffer_appendBuffer(b$0027, b) {
    Buffer_fold((_arg, x) => {
        Buffer_append(x, b);
    }, void 0, b$0027);
}

export function Buffer_toString(b) {
    return Buffer_toArray(b).join('');
}

